import axios from '../utils/axios';
import { formatDateToIsoString } from '../utils/formatDate';

// Used for Irrigation
export async function fetchReadingsFromAPI(filters: {
  granularity?: string;
  farmId: string;
  startDate: string;
  endDate: string;
  sensorType?: string;
  sectorId?: string;
  wiseconnZoneId?: string;
  hourInterval?: number;
  name?: string;
  telemetryType?: string;
  sn?: string;
  chart?: string;
  isWeatherStation?: boolean;
}) {
  const {
    granularity,
    farmId,
    startDate,
    endDate,
    sensorType,
    sectorId,
    wiseconnZoneId,
    name,
    hourInterval,
    telemetryType,
    sn,
    chart,
    isWeatherStation,
  } = filters;

  let baseEndpoint = '/api/readings';

  if (granularity) {
    baseEndpoint += `/${granularity}`;
  }

  try {
    const requestParams = {
      farmId,
      startDate: formatDateToIsoString(startDate),
      endDate: formatDateToIsoString(endDate),
      sensorType,
      ...(sectorId && { sectorId }),
      ...(wiseconnZoneId && wiseconnZoneId.trim() !== '' && { wiseconnZoneId }),
      ...(name && { name }),
      ...(hourInterval && { hourInterval }),
      ...(telemetryType && { telemetryType }),
      ...(sn && sn.trim() !== '' && { sn }),
      ...(chart && { chart }),
      ...(isWeatherStation !== undefined && { isWeatherStation }),
    };

    const response = await axios.get(baseEndpoint, {
      params: requestParams,
    });

    return response.data.readings || [];
  } catch (error) {
    console.error('Error fetching readings:', error);
    throw new Error('Failed to fetch readings');
  }
}

export default {
  fetchReadingsFromAPI,
};
